import useBackend from '@shared/hooks/useBackend'

import config from '@shared/config'

function systemNotification() {
  const { doGet, setup } = useBackend()

  setup('/portalconfiguration/v2', config.microserviceBaseUrl)

  async function getSystemNotifications(
    {
      language,
      channel = 'PET'
    }
  ) {
    const response = await doGet({
      url: '/public/system-notifications', params: {
        lang: language.toLowerCase(),
        channel,
      }
    })

    return response.data
  }

  return {
    getSystemNotifications,
  }
}

export default systemNotification()
